// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"b9d63d33","283":"5c3acb78","289":"62495b9a","364":"fd7d6406","453":"8701dc61","713":"0fabc5f8"}[chunkId] + ".chunk.js";
};